import React from 'react';
import { ReactComponent as CancelTripIcon } from 'assets/icons/cancel-trip.svg';
import { ReactComponent as CompleteTripIcon } from 'assets/icons/complete-trip.svg';
import { ReactComponent as RequestDeliveryIcon } from 'assets/icons/gray-box.svg';
import { ReactComponent as ChangeAddressIcon } from 'assets/icons/change-address.svg';
import { ReactComponent as UpdateSurgeIcon } from 'assets/icons/update-surge.svg';
import { ReactComponent as SwitchToPickupIcon } from 'assets/icons/switch-to-pickup.svg';
import { ReactComponent as ReassignRiderIcon } from 'assets/icons/reassign-rider.svg';
import { ReactComponent as UnassignRiderIcon } from 'assets/icons/unassign-rider.svg';
import { ReactComponent as DispatchOrderIcon } from 'assets/icons/dispatch-order.svg';
import { ReactComponent as PushNotificationIcon } from 'assets/icons/push-notification.svg';
import { ReactComponent as AssignRiderIcon } from 'assets/icons/assign-rider.svg';
import { SurgeFilledIcon, UserAltIcon } from 'cokitchen-icons';
import { BaseDropdownListType } from 'components/base/dropdown-list';

export enum ENUM_LIVE_CARD_MENU {
  COMPLETE_TRIP = 'completeTrip',
  CANCEL_TRIP = 'cancelTrip',
  DISPATCH_ORDER = 'dispatchOrder',
  PUSH_NOTIFICATIONS = 'pushNotifications',
  REASSIGN_RIDER = 'reassignRider',
  ASSIGN_RIDER = 'assignRider',
  UNASSIGN_RIDER = 'unassignRider',
  SWITCH_TO_PICKUP = 'switchToPickup',
  SWITCH_TO_DELIVERY = 'switchToDelivery',
  UPDATE_SURGE = 'updateSurge',
  CHANGE_ADDRESS = 'changeAddress',
  COMPLETE_ORDER = 'completeOrder',
  RECALL_ORDER = 'recallOrder',
  START_ORDER = 'startOrder',
  REASSIGN_REP = 'reassignRep',
  CONFIRM_PAYMENT = 'confirmPayment',
  UPDATE_KITCHEN_SURGE = 'updateKitchenSurge',
  ESCALATE_ORDER = 'escalateOrder',
  RECALLED_ORDER_CS = 'recalledOrderCs',
  REQUEST_DELIVERY_FROM_SHIPBUBBLE = 'requestDeliveryFromShipbubble',
  CHANGE_DELIVERY_PARTNER = 'changeDeliveryPartner'
}

export type LiveCardListType = BaseDropdownListType & {
  key: ENUM_LIVE_CARD_MENU;
};

export const LOGISTICS_LIVE_CARD_LIST: Record<string, LiveCardListType[]> = {
  ongoing: [
    {
      name: 'Change address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Update surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    // {
    //   name: 'Reassign delivery partner',
    //   icon: <TruckIcon />,
    //   key: ENUM_LIVE_CARD_MENU.CHANGE_DELIVERY_PARTNER
    // },
    {
      name: 'Switch to pickup',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_PICKUP
    },
    {
      name: 'Switch to delivery',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_DELIVERY
    },
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    },
    {
      name: 'Re-assign rider',
      icon: <ReassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_RIDER
    },
    {
      name: 'Un-assign rider',
      icon: <UnassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.UNASSIGN_RIDER
    }
  ],
  pending: [
    {
      name: 'Change Address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Update Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    // {
    //   name: 'Reassign delivery partner',
    //   icon: <TruckIcon />,
    //   key: ENUM_LIVE_CARD_MENU.CHANGE_DELIVERY_PARTNER
    // },
    {
      name: 'Switch to pickup',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_PICKUP
    },
    {
      name: 'Switch to delivery',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_DELIVERY
    },
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    }
  ],
  processing: [
    {
      name: 'Complete order',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_ORDER,
      className: 'text-[#46AE31]'
    },
    {
      name: 'Request delivery from shipbubble',
      icon: <RequestDeliveryIcon />,
      key: ENUM_LIVE_CARD_MENU.REQUEST_DELIVERY_FROM_SHIPBUBBLE,
      className: 'text-[#858585]'
    },
    // {
    //   name: 'Reassign delivery partner',
    //   icon: <TruckIcon />,
    //   key: ENUM_LIVE_CARD_MENU.CHANGE_DELIVERY_PARTNER
    // },
    {
      name: 'Dispatch order',
      icon: <DispatchOrderIcon />,
      key: ENUM_LIVE_CARD_MENU.DISPATCH_ORDER,
      className: 'text-[#0EA3FD]'
    },
    {
      name: 'Assign rider',
      icon: <AssignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.ASSIGN_RIDER
    },
    {
      name: 'Change address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Update surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    {
      name: 'Switch to pickup',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_PICKUP
    },
    {
      name: 'Switch to delivery',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_DELIVERY
    },
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    }
  ],
  ready: [
    {
      name: 'Complete trip',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_TRIP,
      className: 'text-[#46AE31]'
    },
    {
      name: 'Request delivery from shipbubble',
      icon: <RequestDeliveryIcon />,
      key: ENUM_LIVE_CARD_MENU.REQUEST_DELIVERY_FROM_SHIPBUBBLE,
      className: 'text-[#858585]'
    },
    // {
    //   name: 'Reassign delivery partner',
    //   icon: <TruckIcon />,
    //   key: ENUM_LIVE_CARD_MENU.CHANGE_DELIVERY_PARTNER
    // },
    {
      name: 'Dispatch order',
      icon: <DispatchOrderIcon />,
      key: ENUM_LIVE_CARD_MENU.DISPATCH_ORDER,
      className: 'text-[#0EA3FD]'
    },
    {
      name: 'Assign rider',
      icon: <AssignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.ASSIGN_RIDER
    },
    {
      name: 'Re-assign rider',
      icon: <ReassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_RIDER
    },
    {
      name: 'Un-assign rider',
      icon: <UnassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.UNASSIGN_RIDER
    },
    {
      name: 'Change address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Update surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    {
      name: 'Switch to pickup',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_PICKUP
    },
    {
      name: 'Switch to delivery',
      icon: <SwitchToPickupIcon />,
      key: ENUM_LIVE_CARD_MENU.SWITCH_TO_DELIVERY
    },
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    }
  ],
  recalled: [
    {
      name: 'Re-assign rider',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_RIDER,
      className: ''
    },

    {
      name: 'Dispatch order',
      icon: <DispatchOrderIcon />,
      key: ENUM_LIVE_CARD_MENU.DISPATCH_ORDER,
      className: 'text-[#0EA3FD]'
    }
  ]
};

export const KITCHEN_LIVE_CARD_LIST: Record<string, LiveCardListType[]> = {
  unpaid: [
    {
      name: 'Reject order',
      icon: <CancelTripIcon />,
      key: ENUM_LIVE_CARD_MENU.CANCEL_TRIP,
      className: 'text-[#E60A2B]'
    },

    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    }
  ],
  pending: [
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    },
    {
      name: 'Start order',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.START_ORDER,
      className: 'text-[#46AE31]'
    }
  ],
  processing: [
    {
      name: 'Complete order',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_ORDER,
      className: 'text-[#46AE31]'
    },
    {
      name: 'Update kitchen surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_KITCHEN_SURGE
    },
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    }
  ],
  dispatched: [
    {
      name: 'Dispatch order',
      icon: <DispatchOrderIcon />,
      key: ENUM_LIVE_CARD_MENU.DISPATCH_ORDER,
      className: 'text-[#0EA3FD]'
    },
    {
      name: 'Recall order',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.RECALL_ORDER
    },

    {
      name: 'Update kitchen surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_KITCHEN_SURGE
    },
    {
      name: 'Push notification to user',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.PUSH_NOTIFICATIONS
    }
  ],
  recalled: [
    {
      name: 'Complete order',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_ORDER,
      className: 'text-[#46AE31]'
    }
  ]
};

export const CS_LIVE_CARD_LIST: Record<string, LiveCardListType[]> = {
  recalled: [
    {
      name: 'Complete trip',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_TRIP,
      className: 'text-[#46AE31]'
    }
  ],
  ongoing: [
    {
      name: 'Recall order',
      icon: <PushNotificationIcon />,
      key: ENUM_LIVE_CARD_MENU.RECALLED_ORDER_CS
    },
    {
      name: 'Re-assign rep.',
      icon: <UserAltIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_REP
    },
    {
      name: 'Re-assign rider',
      icon: <UserAltIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_RIDER
    },
    {
      name: 'Un-assign rider',
      icon: <UnassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.UNASSIGN_RIDER
    },
    {
      name: 'Escalate Order',
      icon: <SurgeFilledIcon />,
      key: ENUM_LIVE_CARD_MENU.ESCALATE_ORDER
    },
    {
      name: 'Update Kitchen Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_KITCHEN_SURGE
    },
    {
      name: 'Update Logistics Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    {
      name: 'Change Address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Complete trip',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_TRIP,
      className: 'text-[#46AE31]'
    },
    {
      name: 'Cancel trip',
      icon: <CancelTripIcon />,
      key: ENUM_LIVE_CARD_MENU.CANCEL_TRIP,
      className: 'text-[#E60A2B]'
    }
  ],
  pending: [
    {
      name: 'Re-assign rep.',
      icon: <UserAltIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_REP
    },
    {
      name: 'Escalate Order',
      icon: <SurgeFilledIcon />,
      key: ENUM_LIVE_CARD_MENU.ESCALATE_ORDER
    },
    {
      name: 'Change Address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Cancel trip',
      icon: <CancelTripIcon />,
      key: ENUM_LIVE_CARD_MENU.CANCEL_TRIP,
      className: 'text-[#E60A2B]'
    },
    {
      name: 'Confirm Payment',
      icon: <DispatchOrderIcon />,
      key: ENUM_LIVE_CARD_MENU.CONFIRM_PAYMENT
    }
  ],
  processing: [
    {
      name: 'Re-assign rep.',
      icon: <UserAltIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_REP
    },
    {
      name: 'Escalate Order',
      icon: <SurgeFilledIcon />,
      key: ENUM_LIVE_CARD_MENU.ESCALATE_ORDER
    },
    {
      name: 'Update Kitchen Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_KITCHEN_SURGE
    },
    {
      name: 'Update Logistics Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    {
      name: 'Change Address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    }
  ],
  ready: [
    {
      name: 'Assign Rider',
      icon: <AssignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.ASSIGN_RIDER
    },
    {
      name: 'Re-assign rep.',
      icon: <UserAltIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_REP
    },
    {
      name: 'Re-assign rider',
      icon: <ReassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.REASSIGN_RIDER
    },
    {
      name: 'Un-assign rider',
      icon: <UnassignRiderIcon />,
      key: ENUM_LIVE_CARD_MENU.UNASSIGN_RIDER
    },
    {
      name: 'Escalate Order',
      icon: <SurgeFilledIcon />,
      key: ENUM_LIVE_CARD_MENU.ESCALATE_ORDER
    },
    {
      name: 'Update Kitchen Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_KITCHEN_SURGE
    },
    {
      name: 'Update Logistics Surge',
      icon: <UpdateSurgeIcon />,
      key: ENUM_LIVE_CARD_MENU.UPDATE_SURGE
    },
    {
      name: 'Change Address',
      icon: <ChangeAddressIcon />,
      key: ENUM_LIVE_CARD_MENU.CHANGE_ADDRESS
    },
    {
      name: 'Complete trip',
      icon: <CompleteTripIcon />,
      key: ENUM_LIVE_CARD_MENU.COMPLETE_TRIP,
      className: 'text-[#46AE31]'
    },
    {
      name: 'Cancel trip',
      icon: <CancelTripIcon />,
      key: ENUM_LIVE_CARD_MENU.CANCEL_TRIP,
      className: 'text-[#E60A2B]'
    }
  ],
  unpaid: [
    {
      name: 'Confirm Payment',
      icon: <DispatchOrderIcon />,
      key: ENUM_LIVE_CARD_MENU.CONFIRM_PAYMENT
    },
    {
      name: 'Cancel trip',
      icon: <CancelTripIcon />,
      key: ENUM_LIVE_CARD_MENU.CANCEL_TRIP,
      className: 'text-[#E60A2B]'
    }
  ]
};
